import cn from 'classnames';
import s from './Spinner.module.scss';

export default function Spinner({ className }) {
  return (
    <div className={cn(s.wrapper, className)}>
      <span className="fa-solid fa-spinner fa-spin" />
    </div>
  );
}
